/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Report16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8.905 1A6.09 6.09 0 0115 7.084a6.09 6.09 0 01-6.095 6.084H7.83l-.106.024-3.648 1.736a.737.737 0 01-1.053-.69l.092-2.546A6.065 6.065 0 011 7.084 6.09 6.09 0 017.095 1zm0 1h-1.81A5.09 5.09 0 002 7.084c0 1.488.644 2.883 1.768 3.85l.363.314-.008.24-.085 2.351 3.306-1.573.105-.037.215-.048.11-.013h1.131A5.09 5.09 0 0014 7.084 5.09 5.09 0 008.905 2zM8 8.685c.276 0 .5.223.5.496v.823a.503.503 0 01-.5.496.498.498 0 01-.5-.496v-.823c0-.274.232-.496.5-.496zM8 3.5c.276 0 .5.223.5.509v3.13a.51.51 0 01-.5.51.501.501 0 01-.5-.51V4.01A.51.51 0 018 3.5z"
        />
    </AccessibleSVG>
);

export default Report16;
